import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { colors } from '~/style/global';

export const Container = styled(Button)`
  font-weight: bold;
  color: ${colors.mediumBlue} !important;
  cursor: pointer;
`;
